export default "https://cdn-static.gokick.com/assets/f7932cbd9535e06fbf9353fcd5d5fd5cf044a6ff/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";